import { createMuiStyles } from '../../../../utils/mui';

export const scholarshipDetailStyles = createMuiStyles({
  headerContent: {
    py: { xs: 3, lg: 5 },
    position: 'relative',
    '&::before': {
      content: '""',
      width: '100vw',
      bgcolor: 'grey.50',
      position: 'absolute',
      height: '100%',
      zIndex: -1,
      top: 0,
      display: 'block',
      left: 0,
    },
  },
  headerImage: {
    img: {
      width: '100%',
      maxHeight: '25rem',
      objectFit: 'contain',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  scholarshipStickyCardWrapper: {
    boxShadow: 10,
    borderRadius: '0.5rem',
    position: 'sticky',
    top: '6rem',
    maxHeight: 'calc(100vh - 8rem)',
    overflowY: 'auto',
    bgcolor: 'common.white',
    img: {
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
    },
  },
  stickyCardImage: {
    img: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '100%',
      height: '12.5rem',
      objectFit: 'contain',
      width: '100%',
    },
  },
});
